import { render, staticRenderFns } from "./FlipkartCareOf.vue?vue&type=template&id=24eb36aa&scoped=true"
import script from "./FlipkartCareOf.vue?vue&type=script&lang=js"
export * from "./FlipkartCareOf.vue?vue&type=script&lang=js"
import style0 from "./FlipkartCareOf.vue?vue&type=style&index=0&id=24eb36aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24eb36aa",
  null
  
)

export default component.exports